import { render, staticRenderFns } from "./broadcast-announcement.vue?vue&type=template&id=71154c5a&scoped=true"
import script from "./broadcast-announcement.vue?vue&type=script&lang=js"
export * from "./broadcast-announcement.vue?vue&type=script&lang=js"
import style0 from "./broadcast-announcement.vue?vue&type=style&index=0&id=71154c5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71154c5a",
  null
  
)

export default component.exports